module.exports = __webpack_public_path__ + "img/item20.9b252217.png";